import { Pages } from '@lib/types';
import { FlowType } from '@ace-clublabs/common-membership-api-types';

export interface PageNavigation {
  currentPage: Pages;
  nextPage?: Pages;
  overridePage?: Pages;
}

//Major rocket
const majorRocketPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AddressPage,
  },
  {
    currentPage: Pages.AddressPage,
    nextPage: Pages.BuildMembershipPage, //nextPage will be BuildMembership
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
  {
    currentPage: Pages.ReviewPage,
    nextPage: Pages.AutopayPage,
  },
];

//T-mobile
const tMobilePageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AddressPage,
  },
  {
    currentPage: Pages.AddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
  {
    currentPage: Pages.ReviewPage,
    nextPage: Pages.AutopayPage,
  },
];

//New Join
const newJoinPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AddressPage,
  },
  {
    currentPage: Pages.AddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
  {
    currentPage: Pages.ReviewPage,
    nextPage: Pages.AutopayPage,
  },
];

//Gift
const giftPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.DateSelector,
  },
  {
    currentPage: Pages.DateSelector,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AddressPage,
  },
  {
    currentPage: Pages.AddressPage,
    nextPage: Pages.GiftDonorContactPage,
  },
  {
    currentPage: Pages.GiftDonorContactPage,
    nextPage: Pages.GiftDonorAddressPage,
  },
  {
    currentPage: Pages.GiftDonorAddressPage,
    nextPage: Pages.SendMembershipCardPage,
  },
  {
    currentPage: Pages.SendMembershipCardPage,
    nextPage: Pages.SendGiftCardPage,
  },
  {
    currentPage: Pages.SendGiftCardPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
  {
    currentPage: Pages.ReviewPage,
    nextPage: Pages.AutopayPage,
  },
];

const navigations = {
  [FlowType.MAJOR_ROCKET]: majorRocketPageNavigations,
  [FlowType.GROUPON]: newJoinPageNavigations,
  [FlowType.NEW_JOIN]: newJoinPageNavigations,
  [FlowType.EMPLOYEE]: newJoinPageNavigations,
  [FlowType.T_MOBILE]: tMobilePageNavigations,
  [FlowType.GIFT]: giftPageNavigations,
};

export const getNextPage = (
  currentPage: Pages,
  flowType: FlowType | undefined | null,
  override: boolean = false
): Pages => {
  let nextPage: Pages = Pages.SorryPage;

  if (!flowType) {
    return nextPage;
  }

  const navigation = navigations[flowType];

  const pageNavigation = navigation?.filter((i) => i.currentPage === currentPage)[0];

  if (pageNavigation == null || pageNavigation.nextPage == null || (override && pageNavigation.overridePage == null))
    return nextPage;

  if (override && pageNavigation.overridePage != null && pageNavigation.overridePage != undefined)
    nextPage = pageNavigation.overridePage;
  else nextPage = pageNavigation.nextPage;

  return nextPage;
};
